import { styled, Button } from '@clickcease/cc-client-components-lib'

export const PlanBoxStyled = styled('div', {
  position: 'relative',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  minHeight: '422px',
  padding: '$12',
  background: '$white',
  boxShadow: '$dropDown',
  border: 'solid 0px transparent',
  borderRadius: '$medium',
  color: '$black',
  cursor: 'default',

  '@bp1': {
    width: '259px',
    minHeight: '445px',
  },

  '@laptop': {
    height: '445px',
  },
  variants: {
    pointerCursor: {
      true: {
        cursor: 'pointer',
      },
    },

    bundle: {
      true: {
        maxWidth: '212px',
        padding: '$12 $10',
        border: 'solid 2px transparent',
        '@laptop': {
          maxWidth: '250px',
          height: '450px',
        },
      },
    },
    setBorder: {
      true: {
        border: '$primaryColor 2px solid',
      },
    },
    crossSell: {
      true: {
        '@laptop': {
          width: '230px',
          padding: '$12 $6',
          '> div': {
            marginRight: '0',
          },
        },
      },
    },
  },
})

export const PlanBoxPlanName = styled('div', {
  fontSize: '$h1',
  fontWeight: '$sb',
})

export const PlanBoxPlanNameWrapper = styled('div', {
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingBottom: '$8',
  marginBottom: '$8',
  borderBottom: '$veryLightNeutral 1px solid',
})

export const PlanBoxBestForAgencies = styled('div', {
  background: '$tableSelected',
  textAlign: 'center',
  color: '$primaryColor',
  fontWeight: '$sb',
  fontSize: '$sm',
  lineHeight: '19px',
  position: 'absolute',
  top: '1px',
  right: '-51px',
  transform: 'rotate(32deg)',
  width: '70px',
  height: '45px',
  padding: '8px 57px 0px 85px',

  variants: {
    bundle: {
      true: {
        top: '1px',
        right: '-51px',
        fontSize: '$code',
        padding: '0px $3',
      },
    },
    es: {
      true: {
        lineHeight: '13px',
      },
    },
  },
})

export const PlanBoxPriceStyled = styled('div', {
  display: 'flex',
  marginTop: '$5',

  '@bp1': {
    justifyContent: 'center',
    marginTop: '0px',
  },
})

export const PlanBoxLetsTalk = styled('div', {
  fontWeight: '$sb',
  fontSize: '$h1',
  margin: '28px 0px 27px 0px',
})

export const PlanBoxCurrency = styled('div', {
  fontSize: 'h3',
  fontWeight: '$sb',
  lineHeight: '60px',
  height: '50px',
})

export const PlanBoxAmount = styled('div', {
  fontSize: '36px',
  fontWeight: '800',
})

export const PlanBoxPeriod = styled('div', {
  fontSize: '$lg',
  fontWeight: '$r',
  lineHeight: '63px',
})

export const PlanBoxOriginalPrice = styled('div', {
  fontSize: '$lg',
  fontWeight: '$r',
  margin: '$10 0px 0px $6',
  position: 'relative',

  '&:before': {
    position: 'absolute',
    content: '',
    left: '-5px',
    top: '20%',
    width: '53px',
    right: '0',
    borderTop: '$primaryColor 1px solid',

    '-webkit-transform': 'rotate(342deg)',
    '-moz-transform': 'rotate(342deg)',

    '-ms-transform': 'rotate(342deg)',
    '-o-transform': 'rotate(342deg)',
    transform: 'rotate(342deg)',
  },
})

export const PlanBoxBilledAnnually = styled('div', {
  fontSize: '$sm',
  fontWeight: '$r',
  display: 'flex',
})

export const PlanBoxBilledAnnuallyText = styled('span', {})
export const PlanBoxAnnuallyOrMonthlyText = styled('div', {
  marginLeft: '$2',
})

export const PlanBoxUpToWebsites = styled('div', {
  display: 'flex',
  fontSize: '$lg',
  fontWeight: '$l',
  marginTop: '$8',
  justifyContent: 'left',
  gap: '$2',

  span: {
    display: 'contents',
    margin: 'unset',
  },
})

export const PlanBoxUpToVisits = styled(PlanBoxUpToWebsites, {
  marginTop: '$5',
})

export const PlanBoxSeparator = styled('span', {
  background: '$lightNeutral',
  height: '1px',
  width: '100%',
  marginTop: '$8',
})

export const PlanBoxFeaturesWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  marginTop: '$8',

  '@laptop': {
    marginTop: '$2',
  },
  ':has(& + button) &': {
    marginBottom: '$10',
  },
})

export const PlanBoxFeatureRow = styled('div', {
  display: 'flex',
  marginTop: '$5',
})

export const EnterprisePlanUnlimited = styled('div', {
  display: 'inline-block',
  marginTop: '$9',
})

export const EnterpriseUpBold = styled('span', {
  marginRight: '5px',
  fontWeight: '$sb',
})

export const PlanBoxFeatureRowText = styled('div', {
  display: 'flex',
  width: '250px',
  marginLeft: '$4',
  fontSize: '$lg',
  fontWeight: '$r',
  textAlign: 'left',

  variants: {
    crossSell: {
      true: {
        '@laptop': {
          fontSize: '$sm',
          width: '200px',
        },
      },
    },
  },
})

export const BundlePlanBoxPriceRow = styled('div', {
  display: 'flex',
  height: '50px',
})

export const BundlePlanBoxButtonAndPrice = styled('div', {
  display: 'flex',
  flexDirection: 'column',

  '@bp1': {
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
})

export const StartFreeTrialButton = styled(Button, {
  width: 'auto',
  height: '30px',
  maxHeight: '42px',
  maxWidth: 'unset',
  marginTop: '16px',
})

export const PinkTag = styled('div', {
  borderRadius: '23px',
  background: '$tableSelected',
  color: '$buttonHovered',
  fontWeight: '$sb',
  fontSize: '$md',
  padding: '$2 $4',
  width: 'fit-content',
})
